import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'AnchorBlock',
  props: {
    text: {}
  },
  emits: ["swipeToMarket"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "frisbuy-summary-widget__anchor",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('swipeToMarket')))
  }, _toDisplayString(props.text), 1))
}
}

})